import { useTooltip } from "context/TooltipProvider";
import { FC, useState } from "react";
import { editCaseCreationWithupload } from "services/caseServices";
import { CaseCreation } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm } from "utils/helper";

type Props = {
  caseData: CaseCreation;
  onClose: (refetch: boolean) => void;
};

const TerminationForm: FC<Props> = ({ caseData, onClose }) => {
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = useState(false);

  const [terminationReason, setTerminationReason] = useState<string>();
  const [terminationDate, setTerminationDate] = useState<string>();
  // const [attachment, setAttachment] = useState<File | null>();

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  // const handleFile = (file: File | null) => {
  //   setAttachment(file);
  // };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">Terminate Case</h2>
        <p className="text-xs text-gray-500">
          Are you sure you want to terminate this case?
        </p>

        <div className="flex flex-col mt-4 w-full">
          <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
            Reason
          </label>
          <textarea
            rows={4}
            placeholder="Enter reason for termination."
            className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
            name="terminationReason"
            value={terminationReason}
            onChange={(e) => setTerminationReason(e.target.value)}
          />
        </div>
        <div className="flex flex-col mt-4 w-full">
          <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
            Date
          </label>
          <input
            type="date"
            className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
            name="next_trial_appointment"
            value={
              terminationDate
                ? new Date(terminationDate).toISOString().split("T")[0]
                : ""
            }
            min={new Date().toISOString().split("T")[0]}
            onChange={(e) => setTerminationDate(e?.target?.value)}
          />
        </div>
        {/* <div className="mt-4">
          <FileUpload
            label="Termination File"
            fileTypes="*"
            info="Upload Files"
            required={false}
            onChange={handleFile}
          />
        </div> */}

        <div className="mt-4 flex justify-between gap-2">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
            onClick={() => {
              onClose(false);
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                        font-[Poppins] cursor-pointer font-[500] w-full
                        text-base rounded-md hover:bg-white hover:text-[#E90101]
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              editCaseCreationWithupload({
                id: caseData?.id,
                termination_status: true,
                termination_reason: terminationReason,
                termination_date: terminationDate,
                // status:
                // attachment
              })
                .then(() => {
                  setLoading(false);
                  showTooltip("Terminated Successfully!", "success");
                  setTerminationReason("");
                  setTerminationDate("");
                  // setAttachment(null);
                  onClose(true);
                })
                .catch((error) => {
                  setLoading(false);
                  showTooltip(
                    error?.response?.data?.detail ||
                      errorHandlerOnForm(error) ||
                      errorHandler(error) ||
                      "Something went wrong. Please try again.",
                    "error"
                  );
                });
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                {LoadingIcon}
                Loading...
              </div>
            ) : (
              "Terminate"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TerminationForm;
